module.exports = __webpack_public_path__ + "static/media/pharma.757894a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/pharma.png
// module id = 141
// module chunks = 0